import React from "react";
import { X } from "lucide-react";
import "./login-signup.css";

const OtpVerification = ({

    closeAllModals,
    handleVerifyOtp,
    otp,
    otpVerificationLoading,
    setOtp
}) =>{
     return(
<>
<div className="modal-overlay">
          <div className="modal-container">
            <div className="modal-header">
              <h3>Verify OTP</h3>
              <button className="modal-close" onClick={closeAllModals}>
                <X size={20} />
              </button>
            </div>
            <div className="modal-body">
              <p>Enter the verification code sent to your email</p>
              <form onSubmit={handleVerifyOtp}>
                <div className="form-group">
                  <input
                    type="text"
                    placeholder="Enter OTP"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    required
                  />
                </div>
                <button type="submit" className="submit-button" disabled={otpVerificationLoading}>
                  {otpVerificationLoading ? (
                    <span className="loading-spinner">
                      <span className="spinner"></span>
                      Verifying...
                    </span>
                  ) : (
                    "Verify OTP"
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
</>
     )
}
export default OtpVerification